/**
 * <MatchingStatsStrip country />  - how well Retail PO item codes match master SKUs (GET /api/ai/sku-matching-stats),
 * as one StatStrip row on the Code Mappings page. Moved here from the old AI page.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getAuthHeaders } from '../contexts/AuthContext';
import { StatStrip } from './StatStrip';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export const MatchingStatsStrip = ({ country }) => {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    const controller = new AbortController();
    axios.get(`${API}/ai/sku-matching-stats`, { params: { country }, headers: getAuthHeaders(), signal: controller.signal })
      .then(res => setStats(res.data))
      .catch(() => { if (!controller.signal.aborted) setStats(null); });
    return () => controller.abort();
  }, [country]);
  if (!stats || !stats.total_items) return null;
  return (
    <StatStrip testId="matching-stats" items={[
      { key: 'accuracy', label: 'of PO item codes matched', value: `${stats.accuracy_pct}%`, tone: stats.accuracy_pct >= 95 ? 'green' : stats.accuracy_pct >= 80 ? 'amber' : 'red', hint: 'Retail PO item codes that resolved to a master SKU' },
      { key: 'unmatched', label: 'unmatched', value: stats.unmatched_items, tone: 'red', hint: 'PO items still needing a mapping' },
      { key: 'exact', label: 'exact matches', value: stats.exact_matches, tone: 'blue' },
      { key: 'auto', label: 'auto-learned', value: stats.auto_learned_matches, tone: 'purple', hint: `${stats.recent_auto_learned} learned in the last 30 days` },
      { key: 'aliases', label: 'mappings', value: stats.total_aliases, tone: 'gray' },
    ]} />
  );
};

export default MatchingStatsStrip;
